import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import Tooltip from 'components/atoms/tooltip';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class UserPointsType extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('UserPointsType', value));
    }

    getOptions() {
        let {options, sportConfig} = this.props;

        options = options || {
            adminPoints: 'Proj',
        };

        if (sportConfig.isModeBacktest() && inArray(sportConfig.getSport(), Const.BACKTEST_SPORTS)) {
            options.fantasyPoints = 'Final FPts';
        }

        return options;
    }

    getTooltipSubject() {
        const {tooltip = 'Choose from basic linear projections or the more advanced Projection system'} = this.props;
        return tooltip;
    }

    render() {
        const {userPointsType} = this.props;
        const options = this.getOptions();

        if (Object.keys(options).length < 2) {
            return null;
        }

        return (
            <div className="input-info">
                <Tooltip subject={this.getTooltipSubject()} />
                <SimpleSelect
                    key={userPointsType.getUserPointsType()}
                    value={userPointsType.getUserPointsType()}
                    options={options}
                    onChange={::this.onChange}
                    testId="projection-system-dropdown"
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {userPointsType, sportConfig} = state;

    return {
        userPointsType,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(UserPointsType);
